module.exports = __webpack_public_path__ + "static/media/0.b615b4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/0.png
// module id = 719
// module chunks = 0